import { render } from "./HeroiconsOutlineBell.vue?vue&type=template&id=65b619cb"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBell.vue"]])

export default __exports__